import { render, staticRenderFns } from "./YearlyStatusReport.vue?vue&type=template&id=be2f7892&"
import script from "./YearlyStatusReport.vue?vue&type=script&lang=ts&"
export * from "./YearlyStatusReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports